import React from "react";
import { useTranslation } from "react-i18next";
import Header from "../../components/appLayout/header";
import SEO from "../../components/SEO";

export default function MentionsLegales() {
  const { t } = useTranslation();

  const company = {
    name: "MSIT Conseil",
    form: "Société à responsabilité limitée",
    siret: "84444013100010",
    address: "10 LE CLOS FOURNIER, 78780 MAURECOURT France",
    email: "contact@msit-conseil.fr",
    phone: "+33 01 30 74 51 19",
    director: "Sofiene Mlouka",
  };

  return (
    <div>
      <SEO
        title="Mentions Légales - MSIT Conseil"
        description="Mentions légales de MSIT Conseil. Informations sur la société, les conditions d'utilisation et les données personnelles."
        keywords="mentions légales, MSIT Conseil, conditions d'utilisation, données personnelles"
        url="https://www.msit-conseil.fr/mentions-legales"
        noindex={true}
        breadcrumbs={[
          { name: "Accueil", url: "https://www.msit-conseil.fr/" },
          { name: "Mentions Légales", url: "https://www.msit-conseil.fr/mentions-legales" }
        ]}
      />
      <Header />
      <section className="prose lg:prose-xl mx-auto p-6 bg-white rounded-2xl shadow-sm container mt-5 mb-5">
        <h1>{t("mentions.title", { company: company.name })}</h1>

        <h2>{t("mentions.section1.title")}</h2>
        <p>{t("mentions.section1.text")}</p>
        <ul>
          <li>
            <strong>{t("mentions.companyName")}:</strong> {company.name}
          </li>
          <li>
            <strong>{t("mentions.companyForm")}:</strong> {company.form}
          </li>
          <li>
            <strong>{t("mentions.address")}:</strong> {company.address}
          </li>
          <li>
            <strong>{t("mentions.siret")}:</strong> {company.siret}
          </li>
          <li>
            <strong>{t("mentions.phone")}:</strong>{" "}
            <a href={`tel:${company.phone}`}>{company.phone}</a>
          </li>
          <li>
            <strong>Email:</strong>{" "}
            <a href={`mailto:${company.email}`}>{company.email}</a>
          </li>
        </ul>
        <p>
          <strong>{t("mentions.director")}:</strong> {company.director}
        </p>

        <h2>{t("mentions.section3.title")}</h2>
        <p>{t("mentions.section3.text", { company: company.name })}</p>

        <h2>{t("mentions.section4.title")}</h2>
        <p>{t("mentions.section4.text1", { company: company.name })}</p>
        <p>
          {t("mentions.section4.text2")} {company.name}
        </p>
        <p>
          {t("mentions.section4.text3")}{" "}
          <a href={`mailto:${company.email}`}>{company.email}</a>.
        </p>
        <p>{t("mentions.section4.text4")}</p>

        <h2>{t("mentions.section5.title")}</h2>
        <p>{t("mentions.section5.text1")}</p>
        <p>{t("mentions.section5.text2")}</p>

        <h2>{t("mentions.section6.title")}</h2>
        <p>{t("mentions.section6.text", { company: company.name })}</p>

        <h2>{t("mentions.section7.title")}</h2>
        <p>{t("mentions.section7.text1")}</p>
        <ul>
          <li>
            {t("mentions.section7.contact1")}{" "}
            <a href={`mailto:${company.email}`}>{company.email}</a>
          </li>
          <li>
            {t("mentions.section7.contact2")} {company.address}
          </li>
          <li>
            {t("mentions.section7.contact3")}{" "}
            <a href={`tel:${company.phone}`}>{company.phone}</a>
          </li>
        </ul>

        <footer className="mt-6 text-sm text-gray-600">
          <p>
            {t("mentions.lastUpdate")}: {new Date().toLocaleDateString("fr-FR")}
          </p>
        </footer>
      </section>{" "}
    </div>
  );
}
